module.exports = __webpack_public_path__ + "img/pool-side.1be949e2.jpg";